import {
  User, Building2, Image 
} from 'lucide-react';
import type { Message } from '../../types/discrepancy';

interface MessageBubbleProps {
  readonly message: Message;
  readonly onImageClick: (url: string) => void;
}

function formatTime(dateStr: string) {
  return new Date(dateStr).toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function MessageBubble({
  message, onImageClick 
}: MessageBubbleProps) {
  const isReceiver = message.senderRole === 'receiver';

  return (
    <div className={`flex gap-2 mb-3 ${isReceiver ? 'flex-row-reverse' : ''}`}>
      <div
        className={`flex-shrink-0 h-7 w-7 rounded-full flex items-center justify-center ${
          isReceiver ? 'bg-slate-900 text-white' : 'bg-slate-100 text-slate-600'
        }`}
      >
        {isReceiver ? <User className="h-3.5 w-3.5" /> : <Building2 className="h-3.5 w-3.5" />}
      </div>
      <div className={`max-w-[75%] ${isReceiver ? 'text-right' : ''}`}>
        <div
          className={`rounded-lg px-3 py-2 ${
            isReceiver ? 'bg-slate-900 text-white' : 'bg-slate-100 text-slate-900'
          }`}
        >
          <p className="text-sm">{message.content}</p>
        </div>

        {message.attachments && message.attachments.length > 0 && (
          <div className={`flex gap-2 mt-2 flex-wrap ${isReceiver ? 'justify-end' : ''}`}>
            {message.attachments.map((att) => (
              <button
                key={att.attachmentId}
                type="button"
                onClick={() => onImageClick(att.fileUrl)}
                className="relative group"
              >
                <img
                  src={att.thumbnailUrl ?? att.fileUrl}
                  alt={att.fileName}
                  className="h-16 w-16 object-cover rounded-md border border-slate-200 hover:border-slate-400 transition-colors"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 rounded-md transition-colors flex items-center justify-center">
                  <Image className="h-4 w-4 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
              </button>
            ))}
          </div>
        )}

        <div className={`flex items-center gap-1 mt-1 text-xs text-slate-400 ${isReceiver ? 'justify-end' : ''}`}>
          <span>{message.senderName}</span>
          <span>•</span>
          <span>{formatTime(message.createdAt)}</span>
        </div>
      </div>
    </div>
  );
}
